'use client'

import Link from 'next/link'
import Breadcrumb from '@/components/Breadcrumb'
import { MapPin, Mountain, Waves, Droplets, TreePine, Building2, BookOpen, Flag } from 'lucide-react'
import { event } from '@/lib/analytics'

export default function BrowsePage() {
  const categories = [
    {
      title: 'Countries',
      description: 'Explore all countries and compare their true sizes',
      href: '/true-size-of-countries',
      icon: MapPin,
      count: '195'
    },
    {
      title: 'Continents',
      description: 'Compare the size of continents around the world',
      href: '/true-size-of-continents',
      icon: Mountain,
      count: '7'
    },
    {
      title: 'Territories & Regions',
      description: 'Explore special territories, dependencies, and autonomous regions',
      href: '/true-size-of-territories',
      icon: Flag,
      count: '40+'
    },
    {
      title: 'Oceans',
      description: 'Discover the vast oceans and their true scale',
      href: '/true-size-of-oceans',
      icon: Waves,
      count: '12'
    },
    {
      title: 'Lakes',
      description: 'Compare the size of major lakes worldwide',
      href: '/true-size-of-lakes',
      icon: Droplets,
      count: '9'
    },
    {
      title: 'Islands',
      description: 'Explore islands and their relative sizes',
      href: '/true-size-of-islands',
      icon: TreePine,
      count: '10'
    },
    {
      title: 'Cities',
      description: 'Compare metropolitan areas and urban regions',
      href: '/true-size-of-cities',
      icon: Building2,
      count: '28'
    }
  ]

  return (
    <div className="mx-auto max-w-7xl px-4 md:px-6 py-8">
      <Breadcrumb items={[
        { label: 'Browse' }
      ]} />
      
      <div className="mb-12">
        <h1 className="text-4xl font-bold text-slate-900 mb-4">Browse & Discover</h1>
        <p className="text-slate-600 text-lg max-w-3xl">
          Explore our comprehensive collection of geographical entities. Compare the true size of countries, 
          continents, oceans, lakes, islands, and cities with our interactive map tool.
        </p>
      </div>

      {/* Categories Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {categories.map((category) => {
          const Icon = category.icon
          
          return (
            <Link
              key={category.title}
              href={category.href}
              className="group block p-6 rounded-lg border border-slate-200 bg-white hover:border-sky-300 hover:shadow-md transition-all duration-200"
              onClick={() => event({ action: 'click', category: 'browse', label: category.title.toLowerCase().replace(/\s+/g, '_') })}
            >
              <div className="flex items-start space-x-4">
                <div className="p-3 rounded-lg bg-sky-100 text-sky-600 group-hover:bg-sky-200">
                  <Icon className="h-6 w-6" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-semibold text-slate-900">
                      {category.title}
                    </h3>
                    <span className="text-sm px-2 py-1 rounded bg-slate-100 text-slate-600">
                      {category.count}
                    </span>
                  </div>
                  <p className="text-sm text-slate-600">
                    {category.description}
                  </p>
                </div>
              </div>
            </Link>
          )
        })}
      </div>

    </div>
  )
}
